// Module
var code = ` <strong>Last state: </strong> <span title="{{ \$ctrl.curr.estado }}">{{ \$ctrl.stateDesc }}</span> <span ng-if="::!\$ctrl.simple"> / <strong> by </strong> {{ \$ctrl.curr.revisor }} <strong> at </strong> {{ \$ctrl.curr.fcrevision | date : 'dd MMM yy HH:mm' }}</span> `;
// Exports
module.exports = code;